exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[dir] #configuration-general-internal-tab .vs-tabs--li button.vs-tabs--btn {\n  text-align: end;\n}\n.vs-tooltip {\n  z-index: 99999;\n}\n", ""]);

// exports
